<template>
  <div class="box">
    <div>
      <svg
        width="88"
        height="87"
        viewBox="0 0 88 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.9802 86.354C27.0673 84.9675 22.4344 82.7333 18.2906 79.7522L18.4766 70.8564C18.5152 68.9876 17.8983 67.1644 16.7329 65.7031C15.5675 64.2417 13.9272 63.2346 12.0967 62.8565L3.3709 61.0526C1.39218 56.3469 0.251689 51.3315 0.000976562 46.2329L7.06882 40.833C8.55461 39.6982 9.596 38.0788 10.0121 36.2561C10.4283 34.4334 10.1928 32.5225 9.34676 30.8553L5.31686 22.9154C7.7681 18.4374 10.9768 14.418 14.8006 11.0357L23.4304 13.1957C25.2439 13.6494 27.1589 13.4537 28.8431 12.6427C30.5273 11.8316 31.8743 10.4564 32.6502 8.75576L36.3461 0.655942C38.8559 0.219744 41.3986 0.000936751 43.946 0.00195667C46.5359 0.00195667 49.0739 0.225952 51.5438 0.655942L55.2397 8.75576C56.0157 10.4564 57.3627 11.8316 59.0469 12.6427C60.7311 13.4537 62.6461 13.6494 64.4595 13.1957L73.0873 11.0357C76.9111 14.418 80.1199 18.4374 82.5711 22.9154L78.5432 30.8553C77.6969 32.5223 77.4612 34.433 77.8769 36.2557C78.2927 38.0784 79.3337 39.6979 80.8191 40.833L87.887 46.2329C87.6363 51.3315 86.4958 56.3469 84.5171 61.0526L75.7932 62.8545C73.9628 63.2326 72.3225 64.2397 71.1571 65.7011C69.9917 67.1624 69.3747 68.9856 69.4134 70.8543L69.5974 79.7522C65.4534 82.7326 60.8205 84.9661 55.9077 86.352L49.0599 80.6561C47.623 79.4609 45.813 78.8065 43.944 78.8065C42.075 78.8065 40.265 79.4609 38.8281 80.6561L31.9802 86.354ZM43.944 62.0006C48.7178 62.0006 53.296 60.1042 56.6716 56.7286C60.0472 53.353 61.9436 48.7748 61.9436 44.001C61.9436 39.2272 60.0472 34.6489 56.6716 31.2733C53.296 27.8977 48.7178 26.0014 43.944 26.0014C39.1702 26.0014 34.5919 27.8977 31.2163 31.2733C27.8408 34.6489 25.9444 39.2272 25.9444 44.001C25.9444 48.7748 27.8408 53.353 31.2163 56.7286C34.5919 60.1042 39.1702 62.0006 43.944 62.0006Z"
          fill="url(#paint0_linear_5947_262492)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5947_262492"
            x1="43.944"
            y1="0.00195312"
            x2="43.944"
            y2="86.354"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#EDF1F6" />
            <stop offset="0.489583" stop-color="#DCE1E8" />
            <stop offset="1" stop-color="#ECF1F5" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div>
      <svg
        width="213"
        height="81"
        viewBox="0 0 213 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="106.5"
          cy="40.5"
          rx="106.5"
          ry="40.5"
          fill="url(#paint0_linear_5947_262490)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5947_262490"
            x1="106.5"
            y1="0"
            x2="106.5"
            y2="30.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#DEE2E8" />
            <stop offset="1" stop-color="#F5F5F5" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <h3>The document is still in the development phase,Please check back later for updates</h3>
  </div>
</template>
<script></script>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.box {
  /* margin: 15% auto; */
  text-align: center;
  min-height:80vh;
  padding-top: 10rem;
}
.box h3 {
  color: rgba(0, 0, 0, 0.45);
}
</style>
